import { Component, OnInit } from '@angular/core';
import { CardContent } from 'src/app/components/card/card.component';

@Component({
  selector: 'app-ksasim',
  templateUrl: './ksasim.component.html',
  styleUrls: ['./ksasim.component.scss']
})
export class KsasimComponent implements OnInit {

  exposition: CardContent = {
    title: 'KSASIM',
    subtitle: 'Covid-19 preparedness planning for Saudi Arabia and the Hajj',
    image_source: 'assets/images/KSASIM.png',
  };

  information: CardContent = {
    title: 'Project Info',
    sections: [
      '<h4>Clients, Partners</h4>Ascend, Saudi Arabia Ministry of Health',
      '<h4>Methods</h4>Deterministic Compartmental Modelling',
      '<h4>Technology / Skills</h4>Javascript, Angular, RK4',
      '<h4>Term</h4>2024-2025',
    ]
  };


  constructor() { }

  ngOnInit(): void {
  }

}
